<div class="tools-mobile">
	<feedback-hold *ngIf="(activityLoaded$ | async) && shouldShowFeedbackHold()"></feedback-hold>
	<session-list-search-result-info></session-list-search-result-info>
	<session-search></session-search>
</div>

<div class="loading-thumbnail" *ngIf="(activityLoaded$ | async) === false">
	<loading [width]="'70px'" [height]="'70px'"></loading>
</div>

<filter-view-layout
	*ngIf="(currentView$ | async) as currentView"
	class="layout"
	#activityContainer>
	<div class="filter-bar" filter-view-filter-bar [hidden]="dataSourceZeroState.hasZeroState && dataSourceZeroState.errorCode !== 0">
		<div class="tools-desktop-tablet" [ngClass]="{ 'no-feedback-hold': !shouldShowFeedbackHold() }">
			<feedback-hold *ngIf="(activityLoaded$ | async) && shouldShowFeedbackHold()"></feedback-hold>
			<div class="search-container">
				<session-list-search-result-info></session-list-search-result-info>
				<session-search></session-search>
			</div>
		</div>
		<div class="filter-view" [formGroup]="form">
			<div class="filter-container score-filter" *ngIf="shouldShowScoreFilter()">
				<mat-form-field goSelect>
					<mat-label>{{ 'common_filter-by' | translate }}</mat-label>
					<mat-select
						formControlName="scoreFilter"
						disableOptionCentering
						panelClass="offsetPanel">
						<mat-option
							*ngFor="let option of scoreOptions"
							[value]="option">
							{{ scoreFilterTranslations[option] | translate }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<div class="filter-container mine-peer-filter" *ngIf="shouldShowMinePeerFilter()">
				<mat-form-field goSelect>
					<mat-label>{{ 'common_filter-by' | translate }}</mat-label>
					<mat-select
						formControlName="minePeerFilter"
						disableOptionCentering
						panelClass="offsetPanel">
						<mat-option
							*ngFor="let option of minePeerOptions"
							[value]="option">
							{{ minePeerTranslations[option] | translate }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<div class="sort-container">
				<mat-form-field goSelect>
					<mat-label>{{ 'common_sort-by' | translate }}</mat-label>
					<mat-select
						formControlName="sortBy"
						disableOptionCentering
						panelClass="offsetPanel">
						<mat-option
							*ngFor="let option of sortByOptions"
							[value]="option">
							{{ sortOrderTranslations[option] | translate }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
	</div>

	<div class="filter-option"
		[ngClass]="{ 'no-feedback-hold': selectedService.getGroup().hasPresenterRole() || !shouldShowFeedbackHold()}"
		filter-view-options-bar
		[hidden]="dataSourceZeroState.hasZeroState">
		<div class="search-container">
			<session-list-search-result-info></session-list-search-result-info>
			<session-search></session-search>
		</div>
		<button *ngIf="currentView === views.LIST"
			type="button"
			class="icon-btn view-switcher ficon-app-grid"
			data-cy="change-to-grid"
			[matTooltip]="'change-to-grid-view' | translate"
			matTooltipPosition="left"
			(click)="viewStateDataSource.toggleCurrentView()"></button>
		<button *ngIf="currentView === views.GRID"
			type="button"
			class="icon-btn view-switcher ficon-app-list"
			data-cy="change-to-list"
			[matTooltip]="'change-to-list-view' | translate"
			matTooltipPosition="left"
			(click)="viewStateDataSource.toggleCurrentView()"></button>
	</div>

	<div class="filter-content"
		filter-view-content
		*ngIf="!dataSourceZeroState.hasZeroState && !dataSourceZeroState.isLoading"
		(contextmenu)="openMenu($event)">
		<ng-container *ngIf="hasSessions$ | async; else zerostate;">
			<ng-container *ngIf="(shouldShowTestBailedView$ | async) !== true; else zeroStateSingleAttemptActivity;">
				<div class="list-view" *ngIf="currentView === views.LIST">
					<session-table
						(goToSession)="openSession($event)">
					</session-table>
				</div>
				<div class="grid-view" *ngIf="currentView === views.GRID">
					<session-grid
						(openSession)="openSession($event)">
					</session-grid>
				</div>
			</ng-container>

			<ng-template #zeroStateSingleAttemptActivity>
				<ngx-zero-state class="zero-state-single-attempt-activity" data-cy="bailed-test">
					<p zero-state-title translate="session-list_zero-state-bailed-test-title"></p>
					<p zero-state-subtext translate="session-list_zero-state-bailed-test-subtext"></p>
				</ngx-zero-state>
			</ng-template>
		</ng-container>

		<ng-template #zerostate>
			<session-zero-state
				(startActivity)="preStartActivity()"
				(viewInstructions)="viewInstructions()">
			</session-zero-state>
		</ng-template>

		<menu *ngIf="(canStartActivity$$ | async) && !selectedService.getActivity().isConversationBoard()">
			<activity-context-menu
				(viewInstructions)="viewInstructions()"
				[canStartActivity]="canStartActivity$$ | async"
				(onStartActivity)="preStartActivity()"></activity-context-menu>
		</menu>
	</div>

	<!-- Datasource zero state -->
	<div class="filter-zero-state" filter-view-content [hidden]="!dataSourceZeroState.hasZeroState && !dataSourceZeroState.isLoading">
		<data-source-zero-state [dataSource]="sessionListDataSource" (zeroStateChanged)="zeroStateChanged($event)"></data-source-zero-state>
	</div>

	<div class="filter-action"
		filter-view-action-bar
		[hidden]="dataSourceZeroState.hasZeroState">
		<ng-container *ngIf="shouldShowFooterButtons$ | async">
			<button
				class="link-btn view-instructions-btn"
				(click)="viewInstructions()"
				[attr.aria-label]="'session-zero-state_view_instructions' | translate">
				<span class="regular">{{ 'session-zero-state_view_instructions' | translate }}</span>
				<span class="shortened">{{ 'session-zero-state_view_instructions_shortened' | translate}}</span>
			</button>
			<button
				*ngIf="canInvite()"
				class="secondary-btn invite-btn"
				(click)="openInviteModal()"
				translate>
				common_invite
			</button>
			<span
				*ngIf="!selectedService.getActivity().isConversationBoard()"
				[tabindex]="(canStartActivity$$ | async) ? -1 : 0"
				[matTooltip]="getSessionCreationDisabledMessage$$ | async"
				[matTooltipDisabled]="canStartActivity$$ | async"
				[attr.aria-disabled]="(canStartActivity$$ | async) === false"
				matTooltipPosition="above"
				role="button">
				<button
					class="btn primary-btn start-activity-btn"
					data-cy="add-video"
					(click)="preStartActivity()"
					[disabled]="(canStartActivity$$ | async) === false"
					[attr.aria-hidden]="(canStartActivity$$ | async) === false"
					[attr.aria-label]="'session-zero-state_start-activity' | translate">
					<span class="regular">{{ 'session-zero-state_start-activity' | translate }}</span>
					<span class="shortened">{{ 'session-zero-state_start-activity_shortened' | translate}}</span>
				</button>
			</span>

		</ng-container>
	</div>
</filter-view-layout>
